import throttle from 'lodash/throttle';
import './custom_modules/flightsList';

// On document ready
$(function() {


    /**
     * Scrolling calculator on your rights page.
     *
     */
    if($('html[class*="page--your-rights"]').length > 0) {

      var $element = $('.calculator--scrolling');

      if ($element.length > 0){

        if($(window).width() >= 992) {
          var parentTop = $element.parent().offset().top;
          var besideTextHeight = $('.yourrights-article__text').outerHeight();
          var bottomLimit = besideTextHeight - ($element.outerHeight() + 20);
          var $window = $(window);
          $element.css('position', 'absolute');


          var throttled = throttle(function(){

            var currentScrollTop = $window.scrollTop();
            var currentScrollTopShifted = currentScrollTop - parentTop;
            var newTop = (currentScrollTopShifted < 0) ? 0 : currentScrollTopShifted;
            newTop = (newTop > bottomLimit) ? bottomLimit : newTop;
            $element.css('top', newTop);

          }, 300);

          $window.scroll(throttled).trigger('scroll');

        } else {
          // Reinit the position in case it has already be set
          $element.css('position', 'static');
        }
      }
    }

});
